module.exports = __webpack_public_path__ + "static/media/day.255a951b.svg";